// Metric keys
export const METRIC_ALL = 'allMetrics';

// Metric meta attributes
export const METRIC_ATTR_LAST_REFRESHED = 'LAST_REFRESHED';
export const METRIC_ATTR_IS_LOADING = 'IS_LOADING';
